'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorHandlingRoute = function () {
    /**
     * 
     * @param {Express} app 
     * @memberof ErrorHandlingRoute
     */
    function ErrorHandlingRoute(app) {
        (0, _classCallCheck3.default)(this, ErrorHandlingRoute);

        this.app = app;
        this.createRoute = this.createRoute.bind(this);

        this.createRoute();
    }

    (0, _createClass3.default)(ErrorHandlingRoute, [{
        key: 'createRoute',
        value: function createRoute() {
            this.app.use(function (req, res, next) {
                var err = new Error('Not Found');
                _minimajs.log.logger.error('The page not found: ' + req.originalUrl);
                err.status = 404;
                res.render('error-404', {
                    message: err.message,
                    error: err
                });
            });

            this.app.use(function (err, req, res, next) {
                if (err) {
                    _minimajs.log.logger.error('Unexpected exception occurs.', err);
                }

                res.status(err.status || 500);
                res.render('error-500', {
                    message: err.message,
                    error: err
                });
            });
        }
    }]);
    return ErrorHandlingRoute;
}();

exports.default = ErrorHandlingRoute;
//# sourceMappingURL=ErrorHandlingRoute.js.map